<script type="ts">
    import {t} from 'i18n-js';
    import {formatPrice} from '../../i18n';
    import {
        addLocaleToUrl, thumbnailUrlFor,
        checkoutUrl,
    } from '../../nutsandwoods';
    import {isPhone} from '../../svelte/useragent';
    import {fade, slide} from 'svelte/transition';

    const SCOPE = {scope: 'Cart.Flyout'};

    export let visible: boolean = false;

    let productItems: Array<YooconShop.Item> = [];
    let productsGross: number;
    let currency: string;

    (async () => {
        const {cart} = await import('../../yoocon-shop');
        cart.on('update', () => {
            productItems = cart.product_items();
            productsGross = cart.products_gross();
            currency = cart.get_currency();
            const items = cart.items();
            if(productItems.length == 0 && items.length > 0)
                cart.remove_all();
        });
    })();

    let flashTimer: number | undefined;

    function cancelFlash() {
        if(flashTimer) {
            clearTimeout(flashTimer);
            flashTimer = undefined;
        }
    }

    export function flash() {
        cancelFlash();
        visible = true;
        flashTimer = setTimeout(() => {
            flashTimer = undefined;
            visible = false;
        }, 3000);
    }

    export function show() {
        cancelFlash();
        visible = true;
    }

    export function hide() {
        visible = false;
    }
</script>

<!-- Wenn wir hier ein verschachteltes `if` mit `else` machen,
     funktionieren die Animationen nicht mehr. -->

{#if !$isPhone && visible && productItems.length > 0}
<div id="cart"
    transition:fade|local
    on:mouseenter={show}
    on:mouseleave={hide}
>
    <ul>
    {#each productItems as item}
        {@const thumbnailUrl = thumbnailUrlFor(item)}
        <li>
            {#if thumbnailUrl}
                <img src={thumbnailUrl} alt={item.title}>
            {/if}
            <span>
                <span>
                    <a href={addLocaleToUrl(item.website)}>
                        {item.title}
                    {#if item.amount > 1}
                        ({item.amount})
                    {/if}
                    </a>
                </span>
            {#if item.subtitle}
                <small>{item.subtitle}</small>
            {/if}
            </span>
            <span>{formatPrice(item.price_gross(), {unit: currency})}</span>
        </li>
    {/each}
        <li class="total">
            <span>{t('total', SCOPE)}</span>
            <span>{formatPrice(productsGross, {unit: currency})}</span>
        </li>
    </ul>
    <a href={checkoutUrl()} class="button effect-hover-flip"><span>{t('goto-checkout', SCOPE)}</span></a>
</div>
{/if}

{#if $isPhone && visible && productItems.length > 0}
<section id="added-to-cart" transition:slide|local>
    <strong>{t('added-to-cart', SCOPE)}</strong>
    <a class="button effect-hover-flip" href={checkoutUrl()}><span>{t('goto-checkout', SCOPE)}</span></a>
</section>
{/if}
